<template>
  <div>
    <Auth v-if="!$store.user" />
    <Dashboard v-else />
    <notifications group="notifications" position="bottom right" width="364">
      <template slot="body" slot-scope="props">
        <Notify :data="props" />
      </template>
    </notifications>
  </div>
</template>

<script>
import 'remixicon/fonts/remixicon.css';
import Auth from './components/pages/AuthPage';
import Dashboard from './components/pages/DashboardPage';
import Notify from './components/controls/Notify';

export default {
  components: {
    Auth,
    Dashboard,
    Notify
  }
}
</script>

<style lang="scss">
@import '../../../styles/variables.scss';
@import './styles/global.scss';
</style>
